import Typography from '@mui/material/Typography';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

export default function PageHeader({title, subtitle}: PageHeaderProps) {
  return (
    <Typography variant="h4" component="h1" gutterBottom>
      {title}
      {subtitle && (
        <Typography variant="body1" component="p" gutterBottom>
          {subtitle}
        </Typography>
      )}
    </Typography>
  );
}
